import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=c7aa9f3c&scoped=true"
import script from "./Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./Footer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=c7aa9f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7aa9f3c",
  null
  
)

export default component.exports